import {
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { DeviceTypeKeys, DeviceTypes } from '../models/device-types-attributes';

@Directive({
  selector: 'mat-icon[type]',
})
export class TypeIconDirective implements OnChanges {
  @HostBinding('attr.fontSet') fontSet: string = '';
  @Input('type') set type(type: DeviceTypeKeys) {
    this.addType(type);
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['type']) {
      return;
    }
    this.removeType(changes['type'].previousValue);
    this.addType(changes['type'].currentValue);
  }

  private removeType(type: DeviceTypeKeys | undefined) {
    if (!type) {
      return;
    }
    const { icon, fontSet } = DeviceTypes[type];
    this.renderer.removeClass(
      this.el.nativeElement,
      `mat-icon-${DeviceTypeKeys[type]}`
    );
    if (fontSet) {
      this.renderer.removeClass(this.el.nativeElement, fontSet);
      this.renderer.removeClass(this.el.nativeElement, icon);
    } else {
      this.el.nativeElement.innerText = '';
    }
  }

  private addType(type: DeviceTypeKeys | undefined) {
    if (!type) {
      return;
    }
    const { icon, fontSet } = DeviceTypes[type];
    this.renderer.addClass(
      this.el.nativeElement,
      `mat-icon-${DeviceTypeKeys[type]}`
    );
    if (fontSet) {
      this.fontSet = fontSet;
      this.renderer.addClass(this.el.nativeElement, fontSet);
      this.renderer.addClass(this.el.nativeElement, icon);
    } else {
      this.el.nativeElement.innerText = icon;
    }
  }
}
